module.exports = require('../dist/types/providers');
